// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Group: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" enableBackground="new 0 0 24 24" xmlSpace="preserve">
<path d="M12,14.02c-0.8,0-1.6-0.18-2.22-0.53l-8.15-4.6C0.91,8.48,0.5,7.87,0.5,7.22s0.41-1.26,1.13-1.67l8.15-4.6
	c1.25-0.7,3.2-0.7,4.44,0l8.15,4.6c0.72,0.41,1.13,1.01,1.13,1.67s-0.41,1.26-1.13,1.67l-8.15,4.6C13.6,13.84,12.8,14.02,12,14.02z
	 M12,1.82c-0.56,0-1.13,0.12-1.53,0.35l-8.15,4.6C2.01,6.94,1.9,7.12,1.9,7.22S2.01,7.5,2.32,7.67l8.15,4.6
	c0.82,0.46,2.25,0.46,3.07,0l8.15-4.6c0.31-0.17,0.42-0.35,0.42-0.45s-0.11-0.28-0.42-0.45l-8.15-4.6C13.12,1.94,12.56,1.82,12,1.82
	z"/>
<path d="M12,18.85c-0.8,0-1.6-0.18-2.22-0.53l-8.15-4.6C0.91,13.31,0.5,12.7,0.5,12.05s0.41-1.26,1.13-1.67l0.69,1.22
	c-0.31,0.17-0.42,0.35-0.42,0.45s0.11,0.28,0.42,0.45l8.15,4.6c0.82,0.46,2.25,0.46,3.07,0l8.15-4.6c0.31-0.17,0.42-0.35,0.42-0.45
	s-0.11-0.28-0.42-0.45l0.69-1.22c0.72,0.41,1.13,1.01,1.13,1.67s-0.41,1.26-1.13,1.67l-8.15,4.6C13.6,18.67,12.8,18.85,12,18.85z"/>
<path d="M12,23.58c-0.8,0-1.6-0.18-2.22-0.53l-8.15-4.6c-0.72-0.41-1.13-1.01-1.13-1.67s0.41-1.26,1.13-1.67l0.69,1.22
	c-0.31,0.17-0.42,0.35-0.42,0.45s0.11,0.28,0.42,0.45l8.15,4.6c0.82,0.46,2.25,0.46,3.07,0l8.15-4.6c0.31-0.17,0.42-0.35,0.42-0.45
	s-0.11-0.28-0.42-0.45l0.69-1.22c0.72,0.41,1.13,1.01,1.13,1.67s-0.41,1.26-1.13,1.67l-8.15,4.6C13.6,23.4,12.8,23.58,12,23.58z"/>
</svg>;
};

export default React.memo(Group);
